import {
    CREDIT_SET_DATA,
    CREDIT_FORM_SET_DATA,
    RESET_CREDIT_DATA,
    CALCULATOR_SET_DATA,
    TIPO_PERSONA,
} from '../actions';

const INIT_STATE = {
    id: null,
    producto: null,
    subproducto: null,
    tmpSubproducto: null,
    oficina: null,
    monto_solicitado: null,
    plazo_solicitado: null,
    plazo: null,
    fecha_creacion: null,
    calculator: null,
    responsable: null,
    form: {},
    approvalCertificate: {},
    estadoSolicitudCodigo: null,
    total_credito: null,
    total_mensualidad_credito: null,
    ejecutivo: null,
    tipo_persona: 'CLIENTE',
};

const creditReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CREDIT_SET_DATA:
            return Object.assign({}, state, action.payload);
        case CREDIT_FORM_SET_DATA:
            return Object.assign({}, state, { form: action.payload });
        case CALCULATOR_SET_DATA:
            return Object.assign({}, state, { calculator: action.payload });
        case RESET_CREDIT_DATA:
            return Object.assign({}, INIT_STATE);
        case TIPO_PERSONA:
            return Object.assign({}, state, action.payload);
        default:
            return { ...state };
    }
};

export default creditReducer;
